import React, { Component } from "react";

class ResourceLinks extends Component {
  render() {
    return (
      <section id="resources" className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 anim_piece">
              <h3>Javascript</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="http://www.cheatography.com/davechild/cheat-sheets/javascript/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Javascript Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/DrkSephy/es6-cheatsheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ES6 Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/sapegin/jest-cheat-sheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Jest Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://oscarotero.com/jquery/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    jQuery API Reference
                  </a>
                  <ul>
                    <li>
                      <a
                        href="http://lab.abhinayrathore.com/jquery-cheatsheet/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        jQuery Cheatsheet
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://woorkup.com/wp-content/uploads/2011/05/jQuery-1.6-Visual-Cheat-Sheet.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        jQuery Visual Cheatsheet
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    href="https://duck.co/ia/view/lodash_cheat_sheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Lodash Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://reactcheatsheet.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ReactJs Cheatsheet
                  </a>
                  <ul>
                    <li>
                      <a
                        href="https://github.com/refinery29/react-native-cheat-sheet"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        React Native Cheatsheet
                      </a>
                      <ul>
                        <li>
                          <a
                            href="https://github.com/vhpoet/react-native-styling-cheat-sheet"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            React Native Styling Cheatsheet
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a
                        href="https://github.com/uanders/react-redux-cheatsheet"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        React-Redux Cheatsheet
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    href="https://gist.github.com/LeCoupa/985b82968d8285987dc3"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    NodeJs Cheatsheet
                  </a>
                  <ul>
                    <li>
                      <a
                        href="https://git.generalassemb.ly/gist/tfrankie88/bcd73848eecc2e58327df9b0d7699c9f"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Express Cheatsheet
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://docs.google.com/drawings/d/1lEx5fZA-UsmVJOJ2P2P5rbIVyQHB8O0i6u4FyCmaork/edit?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        MeteorJs Cheatsheet
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://downloads.gosquared.com/help_sheets/11/Node%20Help%20Sheet.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        NodeJs Help Sheet
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    href="http://browsenpm.org/help"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    NPM Cheatsheet
                  </a>
                  <ul>
                    <li>
                      <a
                        href="https://shift.infinite.red/npm-vs-yarn-cheat-sheet-8755b092e5cc"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        NPM vs Yarn
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://package.json.nodejitsu.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Package.json Cheatsheet
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    href="http://f.cl.ly/items/093o0l2Y3u130y0W0c0x/underscore-cheat-sheet.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Underscore Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/petehunt/webpack-howto"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Webpack Guide
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-sm-6 anim_piece">
              <h3>Python</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="https://www.pythoncheatsheet.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Python Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://edu.anarcho-copy.org/Programming%20Languages/Python/Python%20CheatSheet/beginners_python_cheat_sheet_pcc_django.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Django Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.codewithharry.com/blogpost/flask-cheatsheet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Flask Cheatsheet
                  </a>
                </li>
              </ul>
              <h3>PHP</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="https://code.google.com/archive/p/codeigniter-2-0-quick-reference-cheat-sheet/downloads"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Codeigniter 2.0 Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://drupalconsole.com/cheatsheet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Drupal Reference Guide
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/jesseobrien/laravel-cheatsheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Laravel Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.cheatography.com/ajay-kumar-b/cheat-sheets/mysqli-procedural-functions/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    MySQLi Procedural Functions Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.codebeaulieu.com/Create-Read-Update-and-Delete-PDO-Cheat-Sheet-PHP"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    PDO Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="http://www.cheatography.com/davechild/cheat-sheets/php/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    PHP Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/tpunt/PHP7-Reference"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    PHP7 Reference
                  </a>
                </li>
                <li>
                  <a
                    href="https://symfony.si/cheatsheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Symfony Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://makeawebsitehub.com/wordpress-mega-cheat-sheet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Wordpress Cheatsheet
                  </a>
                  <ul>
                    <li>
                      <a
                        href="http://www.topdesignmag.com/wp-content/uploads/2012/07/7.-cheat-sheet-600x389.png"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Wordpress Template Hierarchy Map
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://wptoy.com/resources/wordpress-theme-development-check-list-pdf-version/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Wordpress Theme Development Check List
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>

          <div className="row pt-3">
            <div className="col-sm-6 anim_piece">
              <h3>Elixir</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="https://media.pragprog.com/titles/elixir/ElixirCheat.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Elixir Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/benbarber/phoenix-cheatsheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Phoenix Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/benjamintanweihao/elixir-cheatsheets/blob/master/GenServer_CheatSheet.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    GenServer Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/benjamintanweihao/elixir-cheatsheets/blob/master/Supervisor_CheatSheet.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Supervisor Cheatsheet
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-sm-6 anim_piece">
              <h3>DevOps</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="https://intellipaat.com/tutorial/amazon-web-services-aws-tutorial/aws-cheat-sheet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    AWS Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/wsargent/docker-cheat-sheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Docker Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://gist.github.com/austinthecoder/565725"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Heroku Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://kubernetes.io/docs/reference/kubectl/cheatsheet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Kubernetes Cheatsheet
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="row pt-3">
            <div className="col-sm-6 anim_piece">
              <h3>Databases</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="https://github.com/leojavier/MongoDb-cheat-sheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    MongoDb Cheatsheet
                  </a>
                  <ul>
                    <li>
                      <a
                        href="https://gist.github.com/subfuzion/9236165"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Mongoose Cheatsheet
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    href="http://www.cheatography.com/davechild/cheat-sheets/mysql/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    MySQL Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://dzone.com/refcardz/essential-postgresql"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    PostgreSQL Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="http://www.sql-tutorial.net/sql-cheat-sheet.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    SQL Cheatsheet
                  </a>
                  <ul>
                    <li>
                      <a
                        href="http://www.websec.ca/kb/sql_injection"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        SQL Injection
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://coolshell.cn/articles/3463.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        SQL Join Cheatsheet
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <div className="col-sm-6 anim_piece">
              <h3>Version Control</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="http://www.git-tower.com/files/cheatsheet/Git_Cheat_Sheet_grey.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Git Cheatsheet
                  </a>
                  <ul>
                    <li>
                      <a
                        href="https://github.com/arslanbilal/git-cheat-sheet"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Git Cheatsheet and Git Flow
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://github.com/danielkummer/git-flow-cheatsheet"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Git Flow Cheatsheet
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://justinhileman.info/article/git-pretty/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Git Pretty
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://github.com/agis/git-style-guide"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Git Style Guide
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://github.com/tiimgreen/github-cheat-sheet"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Github Cheatsheet
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    href="http://www.abbeyworkshop.com/howto/misc/svn01/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    SVN Cheatsheet
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="row pt-3">
            <div className="col-sm-6 anim_piece">
              <h3>Frontend Frameworks</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="http://yingyingzhang.com/bulma-cheat-sheet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bulma Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="http://creativealive.com/wp-content/uploads/2014/01/bootstrap3-cheatsheet.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bootstrap 3 Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://hackerthemes.com/bootstrap-cheatsheet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bootstrap 4 Cheatsheet
                  </a>
                  <ul>
                    <li>
                      <a
                        href="https://bootstrapcreative.com/resources/bootstrap-4-css-classNamees-index/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Bootstrap 4 Class Names
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://glyphicons.bootstrapcheatsheets.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Bootstrap Glyphicons
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    href="https://material.io/guidelines/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Material Design
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-sm-6 anim_piece">
              <h3>Command Line Interface</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="https://github.com/NisreenFarhoud/Bash-Cheatsheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Bash Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="http://lzone.de/cheat-sheet/Shell-Scripting"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Shell Scripting Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/0nn0/terminal-mac-cheatsheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terminal Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="http://cb.vu/unixtoolbox.xhtml"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Unix Toolbox
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="row pt-3">
            <div className="col-sm-6 anim_piece">
              <h3>HTML</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="https://github.com/audreyr/favicon-cheat-sheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Favicon Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="http://gethead.info/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Head Tag Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="http://htmlcheatsheet.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    HTML Cheatsheet
                  </a>
                  <ul>
                    <li>
                      <a
                        href="http://www.addedbytes.com/cheat-sheets/html-character-entities-cheat-sheet/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        HTML Character Entities Cheatsheet
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://simon.html5.org/dump/html5-canvas-cheat-sheet.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        HTML5 Canvas Cheatsheet
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://meiert.com/en/indices/html-elements/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        HTML5 Elements Index
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://www.testking.com/techking/wp-content/uploads/2011/02/IG-HTML5-Cheatsheet-1000px.png"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        HTML5 Cheatsheet
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://github.com/cure53/H5SC"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        HTML5 Security Cheatsheet
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    href="http://www.ginzametrics.com/cheatsheet"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    SEO Interactive Cheatsheet
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-sm-6 anim_piece">
              <h3>CSS</h3>
              <hr />
              <ul>
                <li>
                  <a
                    href="https://d13yacurqjgara.cloudfront.net/users/248947/screenshots/1742074/attachments/282954/flexboxsheet.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    CSS Flexbox Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://websitesetup.org/wp-content/uploads/2016/10/wsu-css-cheat-sheet.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    CSS3 Cheatsheet
                  </a>
                  <ul>
                    <li>
                      <a
                        href="http://www.justinaguilar.com/animations/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        CSS3 Animation Cheatsheet
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://mac-blog.org.ua/css-3-media-queries-cheat-sheet/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        CSS3 Media Queries Cheatsheet
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://www.topdesignmag.com/wp-content/uploads/2012/07/2.-cheat-sheet-600x324.png"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Periodic Table of CSS3 Syntax
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    href="http://fontawesome.io/cheatsheet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Font Awesome Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.uxpin.com/studio/blog/responsive-web-design-cheat-sheet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Responsive Web Design Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="http://www.addedbytes.com/cheat-sheets/colour-chart/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    RGB Hex Colour Chart
                  </a>
                </li>
                <li>
                  <a
                    href="https://sass-cheatsheet.brunoscopelliti.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    SASS Cheatsheet
                  </a>
                </li>
                <li>
                  <a
                    href="https://gist.github.com/AllThingsSmitty/3bcc79da563df756be46"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    SASS / SCSS Functions Cheatsheet
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="row-pt-3">
            <div className="col-md-12 anim_piece">
              <p className="text-center">
                <br />
                <strong>
                  All guides listed herein are the property of their respective
                  owners.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ResourceLinks;
